export const COMPANY = {
  brand: "İnce Fikirler",
  owner: "Özer Özyön",
  legalName: "Özer Özyön (İnce Fikirler)",
  taxOffice: "Üsküdar",
  taxNo: "7180210313",
  address: "Ahmediye Mah. Dönmedolap Sk. Sütlüoğlu Apt. No:56/A Üsküdar / İstanbul",
  email: "info@incefikirler.tv",
  phone: "+90 532 176 74 41",
  web: "incefikirler.tv",
  activity: "Reklamcılık ile ilgili fotoğrafçılık ve prodüksiyon faaliyetleri",
  since: "2006",
};
